export default {
  goTo: {
    en: '“{brand}” brand page',
  },
}
